/**
 * Carousel Admin Scripts
 *
 * Handles the admin interface for carousel slider selection,
 * drag-and-drop ordering, and dynamic settings management.
 *
 * @package wp-before-after-image-slider
 * @since 2.1.0
 */

(function ($) {
	'use strict';

	/**
	 * Carousel Admin Controller
	 */
	const CarouselAdmin = {
		/**
		 * Initialize
		 */
		init() {
			this.bindEvents();
			this.initSortable();
			this.toggleSettingsVisibility();
		},

		/**
		 * Bind event handlers
		 */
		bindEvents() {
			// Add slider to carousel
			$(document).on('click', '.bais-add-slider', this.addSlider.bind(this));

			// Remove slider from carousel
			$(document).on('click', '.bais-remove-slider', this.removeSlider.bind(this));

			// Search sliders
			$('#bais-slider-search').on('keyup', this.searchSliders.bind(this));

			// Copy shortcode
			$(document).on('click', '.copy-shortcode', this.copyShortcode.bind(this));

			// Toggle autoplay options
			$('#autoplay').on('change', this.toggleAutoplayOptions);

			// Toggle pagination options
			$('#pagination').on('change', this.togglePaginationOptions);
		},

		/**
		 * Initialize sortable for selected sliders
		 */
		initSortable() {
			$('#bais-selected-slider-list').sortable({
				handle: '.bais-drag-handle',
				placeholder: 'bais-slider-placeholder',
				update: function () {
					CarouselAdmin.updateSliderOrder();
				},
			});
		},

		/**
		 * Add slider to carousel
		 */
		addSlider(e) {
			e.preventDefault();

			const $button = $(e.currentTarget);
			const $sliderItem = $button.closest('.bais-slider-item');
			const sliderId = $sliderItem.data('slider-id');

			// Clone the item
			const $clonedItem = $sliderItem.clone();

			// Update button
			$clonedItem
				.find('.bais-slider-actions')
				.html(
					'<button type="button" class="button button-small bais-remove-slider" title="Remove"><span class="dashicons dashicons-no-alt"></span></button><span class="bais-drag-handle dashicons dashicons-menu"></span>'
				);

			// Remove from available list
			$sliderItem.fadeOut(300, function () {
				$(this).remove();
			});

			// Add to selected list
			$('#bais-selected-slider-list').append($clonedItem);
			$clonedItem.hide().fadeIn(300);

			// Update hidden input
			this.updateSliderOrder();
		},

		/**
		 * Remove slider from carousel
		 */
		removeSlider(e) {
			e.preventDefault();

			const $button = $(e.currentTarget);
			const $sliderItem = $button.closest('.bais-slider-item');
			const sliderId = $sliderItem.data('slider-id');

			// Clone the item
			const $clonedItem = $sliderItem.clone();

			// Update button
			$clonedItem
				.find('.bais-slider-actions')
				.html(
					'<button type="button" class="button button-small bais-add-slider" title="Add to Carousel"><span class="dashicons dashicons-plus-alt"></span></button>'
				);

			// Remove from selected list
			$sliderItem.fadeOut(300, function () {
				$(this).remove();
				CarouselAdmin.updateSliderOrder();
			});

			// Add back to available list (alphabetically)
			this.insertSliderAlphabetically($clonedItem);
		},

		/**
		 * Insert slider item alphabetically in available list
		 */
		insertSliderAlphabetically($item) {
			const title = $item.find('h4').text().toLowerCase();
			const $availableList = $('#bais-available-slider-list');
			const $items = $availableList.find('.bais-slider-item');

			let inserted = false;

			$items.each(function () {
				const currentTitle = $(this).find('h4').text().toLowerCase();
				if (title < currentTitle) {
					$item.insertBefore($(this));
					$item.hide().fadeIn(300);
					inserted = true;
					return false;
				}
			});

			if (!inserted) {
				$availableList.append($item);
				$item.hide().fadeIn(300);
			}
		},

		/**
		 * Update slider order in hidden input
		 */
		updateSliderOrder() {
			const sliderIds = [];

			$('#bais-selected-slider-list .bais-slider-item').each(function () {
				sliderIds.push($(this).data('slider-id'));
			});

			$('#carousel-slider-ids').val(sliderIds.join(','));
		},

		/**
		 * Search sliders
		 */
		searchSliders(e) {
			const searchTerm = $(e.target).val().toLowerCase();

			$('.bais-slider-item').each(function () {
				const $item = $(this);
				const title = $item.find('h4').text().toLowerCase();
				const id = $item.data('slider-id').toString();

				if (title.includes(searchTerm) || id.includes(searchTerm)) {
					$item.show();
				} else {
					$item.hide();
				}
			});
		},

		/**
		 * Copy shortcode to clipboard
		 */
		copyShortcode(e) {
			e.preventDefault();

			const $button = $(e.currentTarget);
			const shortcode = $button.data('shortcode');

			// Create temporary input
			const $temp = $('<input>');
			$('body').append($temp);
			$temp.val(shortcode).select();
			document.execCommand('copy');
			$temp.remove();

			// Show feedback
			const originalText = $button.text();
			$button.text('Copied!').addClass('copied');

			setTimeout(function () {
				$button.text(originalText).removeClass('copied');
			}, 2000);
		},

		/**
		 * Toggle autoplay options visibility
		 */
		toggleAutoplayOptions() {
			const isEnabled = $('#autoplay').is(':checked');
			$('.bais-autoplay-option').toggle(isEnabled);
		},

		/**
		 * Toggle pagination options visibility
		 */
		togglePaginationOptions() {
			const isEnabled = $('#pagination').is(':checked');
			$('.bais-pagination-option').toggle(isEnabled);
		},

		/**
		 * Toggle settings visibility based on initial state
		 */
		toggleSettingsVisibility() {
			this.toggleAutoplayOptions();
			this.togglePaginationOptions();
		},
	};

	// Initialize on document ready
	$(document).ready(function () {
		CarouselAdmin.init();
	});
})(jQuery);
